<script setup lang="ts">
import { useProvideLangDir } from "~/composables/provided-state.ts";
import { useDraggingStatusStore } from "~/stores/dragging-status.ts";
import { startPersistentNotificationInitializer } from "~/stores/global-notification.ts";
import AsyncBootupDetails from "~/components/AsyncBootupDetails.vue";
const head = useLocaleHead({ dir: true, seo: true, lang: true });
const draggingStatus = useDraggingStatusStore();
const directionRef = computed<"rtl" | "ltr">(() => <"ltr" | "rtl">head.value.htmlAttrs?.dir ?? "ltr");
const langRef = computed(() => head.value.htmlAttrs?.lang ?? "en");
const htmlStyle = computed(() => `--direction: ${directionRef.value};`);
const htmlClass = computed(() => (draggingStatus.isDragging ? "select-none" : ""));
useHead({
  htmlAttrs: {
    lang: langRef,
    dir: directionRef,
    style: htmlStyle,
    class: htmlClass,
  },
});

useProvideLangDir(directionRef);

// Since we need to call this when we know that we have reloaded the page, this seems like a good place to do it.
startPersistentNotificationInitializer();
</script>
<template>
  <suspense><async-bootup-details /></suspense>
  <LoadingGlobalPage />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <GlobalNotificationBar />
</template>
<style scoped lang="postcss">
/**
intentionally left blank
 */
</style>
<style lang="postcss">
:where(html) {
  --direction: ltr;
}
* {
  direction: var(--direction);
}
</style>
